"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SavedBlockDropzoneInner = exports.SavedBlockDropzoneConfiguration = void 0;
var react_1 = __importStar(require("react"));
var mobx_react_1 = require("mobx-react");
var react_transition_group_1 = require("react-transition-group");
var classnames_1 = __importDefault(require("classnames"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var SavedBlockDropzoneConfiguration;
(function (SavedBlockDropzoneConfiguration) {
    SavedBlockDropzoneConfiguration["InsideBlock"] = "insideblock";
    SavedBlockDropzoneConfiguration["EmptyProject"] = "emptyproject";
})(SavedBlockDropzoneConfiguration = exports.SavedBlockDropzoneConfiguration || (exports.SavedBlockDropzoneConfiguration = {}));
var SavedBlockDropzoneInner = (0, mobx_react_1.observer)((0, react_1.forwardRef)(function (_a, ref) {
    var isActive = _a.isActive, isOpen = _a.isOpen, isInserting = _a.isInserting, onDragOver = _a.onDragOver, configuration = _a.configuration;
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)("saved-block-dropzone", {
            "saved-block-dropzone--open": isOpen,
        }), ref: ref },
        react_1.default.createElement(react_transition_group_1.CSSTransition, { mountOnEnter: true, unmountOnExit: true, in: isOpen, timeout: kaleidoscope_2.AnimationDuration.Long, classNames: "saved-block-dropzone__inner-" },
            react_1.default.createElement("div", { className: (0, classnames_1.default)("saved-block-dropzone__inner", "saved-block-dropzone__inner--".concat(configuration), {
                    "saved-block-dropzone__inner--active": isActive,
                }), onDragOver: onDragOver }, isInserting ? react_1.default.createElement(kaleidoscope_1.Spinner, null) : react_1.default.createElement(react_1.default.Fragment, null, isActive ? "Release to drop block" : "Drag a block here")))));
}));
exports.SavedBlockDropzoneInner = SavedBlockDropzoneInner;
